require("../sass/main.scss");
import ReactDOM from "react-dom";
import React from "react";
import { NestedTabs } from "./components/NestedTabs";
import { TopSelector, BottomSelector } from "../js/components/NestedTabs/models/NestedTabModels";

interface ThreeSixtyView {
  variant: string;
  interiorViewImage: string;
  interiorViewUrl: string;
  interiorDisclaimerOverride: string;
  exteriorViewImage: string;
  exteriorViewUrl: string;
  exteriorDisclaimerOverride: string;
}

const Render360Viewer = (): void => {
  const threeSixtyViewerRoot = document.getElementById("threeSixtyViewer");

  if (threeSixtyViewerRoot) {
    var threeSixtyViews: ThreeSixtyView[] = window["threeSixtyViews"];
    const interiorViewTab: BottomSelector = {
      nodeName: "interior360",
      text: "INTERIOR 360°",
      value: "INTERIOR 360°",
      showIframe: false,
    };
    const exteriorViewTab: BottomSelector = {
      nodeName: "exterior360",
      text: "EXTERIOR 360°",
      value: "EXTERIOR 360°",
      showIframe: false,
    };
    var bottomTabs = [];

    if (threeSixtyViews[0].interiorViewUrl && threeSixtyViews[0].exteriorViewUrl) {
      bottomTabs = [interiorViewTab, exteriorViewTab];
    } else {
      bottomTabs = [interiorViewTab];
    }

    ReactDOM.render(
      <NestedTabs
        topSelector={threeSixtyViews.map<TopSelector>((item) => {
          return {
            text: item.variant,
            value: item.variant,
            selected: true,
            interior: {
              viewDisclaimer: item.interiorDisclaimerOverride ? item.interiorDisclaimerOverride : item.variant,
              viewUrl: item.interiorViewUrl,
              viewImage: item.interiorViewImage,
            },
            exterior: {
              viewDisclaimer: item.exteriorDisclaimerOverride ? item.exteriorDisclaimerOverride : item.variant,
              viewUrl: item.exteriorViewUrl,
              viewImage: item.exteriorViewImage,
            },
          };
        })}
        bottomSelector={bottomTabs}
      />,
      threeSixtyViewerRoot
    );
  }
};

export default Render360Viewer;
